import { Component, OnInit, Input } from '@angular/core';
import { StockChart } from 'angular-highcharts';

@Component({
  selector: 'app-stockchart',
  templateUrl: './stockchart.component.html',
  styleUrls: ['./stockchart.component.scss']
})
export class StockchartComponent implements OnInit {

  @Input() data: any;
  chartdata;
  stock!: StockChart;
  yAxis:any;

  constructor() {
    this.yAxis= {
      lineColor:"var(--graph-text-color)",
      gridLineColor: "var(--gridline-color)",
    lineWidth: 0,
    endOnTick: false,
    labels: {
      style: {
        color: 'var(--graph-text-color)',
        fontSize:'12'
      },
    },
    title: {
      style: {
        color: 'var(--graph-text-color)',
        fontSize: '14'
      }
    },
  }
   }

  ngOnInit() {
    this.plotGraph(this.data)
  }
  
 plotGraph(data){
    
    this.stock = new StockChart({
      chart:{
        reflow:true,
        type:"line",
        style:{fontFamily: 'sfpro-r',color:"var(--primary-text-color)"},
        backgroundColor: "transparent",
        events: data[0].events ? data[0].events : null,
      },
      time: {
        useUTC: false
       },
      credits:{
        enabled:false,
        style:{
        color:'#999999',
        cursor:'pointer',
        fontSize:'9px',
        },
        text:'Highcharts.com'
        },
      rangeSelector: {
        selected: 5,
       buttonTheme:{
         style:{
           color:"#595959",
         },
       states: {
        select: {
            fill: '#2A7CF6',
            style: {
                color: '#FFFFFF'
            }
        }
    },},
     
        // labelStyle:{
        //   color:'blue',
        //   backgroundColor:'blue'
        // },
        // inputStyle:{
        //   color:'red',
        // }
      },
      title: {
        text: ''
      },
      xAxis: {
        lineColor:"#cccccc",
        lineWidth:1,
        ordinal: false,
      type:'datetime',
      tickInterval: 3 * 3600 * 1000,
      title:{
      text:"Time"
      },
      labels: {
          // format: '{value:%d-%m,%H}',
       
        style: {
           color: '#427bff',
           fontSize:'12px',
           type:'datetime',
           tickInterval: 3 * 3600 * 1000,
        },
      },
    },
    
      yAxis: data[0].yaxis?data[0].yaxis:this.yAxis,
    //   
    legend: {
      align: "center",
      enabled:true,
      verticalAlign: "bottom",
      layout: "horizontal",
      squareSymbol: true,
      symbolHeight: 10,
      symbolWidth: 10,
      symbolRadius: 0,
      itemStyle: {
        color: 'var(--graph-text-color)',
        fontWeight: "ligther",
        fontSize: '13',
      },
      y:10
    },
      plotOptions:{
        series:{
          turboThreshold:5000
        }
      },
      series: data[0].series,
    });
}
}
